// extracted by mini-css-extract-plugin
export var container = "_2p-0";
export var disabled = "_2p-3";
export var enabled = "_2p-2";
export var statusLight = "_2p-1";